"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionGroupDefaults_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionGroupV3_1 = require("./PermissionGroupV3");
var PermissionRestrictionPoint_1 = require("./PermissionRestrictionPoint");
var PermissionGroupDefaults_Factory = /** @class */ (function () {
    function PermissionGroupDefaults_Factory() {
    }
    PermissionGroupDefaults_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionBehaviour: model.PermissionBehaviour,
            PermissionGroupDefaultId: model.PermissionGroupDefaultId,
            PermissionGroupId: model.PermissionGroupId,
            PermissionGroupV3: PermissionGroupV3_1.PermissionGroupV3_Factory.CreateIncoming(model.PermissionGroupV3),
            PermissionRestrictionPoint: PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateIncoming(model.PermissionRestrictionPoint),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
        };
        return result;
    };
    PermissionGroupDefaults_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionBehaviour: model.PermissionBehaviour,
            PermissionGroupDefaultId: model.PermissionGroupDefaultId,
            PermissionGroupId: model.PermissionGroupId,
            PermissionGroupV3: PermissionGroupV3_1.PermissionGroupV3_Factory.CreateOutgoing(model.PermissionGroupV3),
            PermissionRestrictionPoint: PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateOutgoing(model.PermissionRestrictionPoint),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
        };
        return result;
    };
    return PermissionGroupDefaults_Factory;
}());
exports.PermissionGroupDefaults_Factory = PermissionGroupDefaults_Factory;
